import React, { useEffect, useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input, Table, TableHeader, TableColumn, TableBody, TableRow, TableCell} from "@nextui-org/react";
import { MdOutlineDelete } from "react-icons/md";
import axios from "axios"
import { toast } from "react-toastify";
import { TYPES } from "../../../../utils/types";
import { product_uri } from "../../../../utils/url";

export default function ProductDetail({id, name}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [data, setData] = useState([]);
  const [pay, setPay] = useState();
  
  
  const Get = async() =>{
    setLoad(true);
    try{
      const res = await axios.get(product_uri+`/detail?id=${id}`);
      setData(res.data);
      console.log(res.data)
      setLoad(false);
    }catch(err){
      setLoad(false);
      console.log(err);
    }
  }

  const Sub = async() =>{
    setLoad(true);
    try{
      const res = await axios.get(product_uri+`/irsen?id=${id}&pay=${pay}`);
      setLoad(false);
      toast.success("Каргоны төлбөр хадгалж барааг ирсэн төлөвт шилжүүллээ !");
    }catch(err){
      setLoad(false);
      console.log(err);
    }
  }

  function open (){
    onOpen();
    Get();
  }

  function sss (s){
    const a = data.filter(it => it.type === s);
    return a.length;
  }

  return (
    <>
      <h1 onClick={open} className='text-sm font-bold cursor-pointer'>{name}</h1>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="5xl">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex justify-between gap-1 font-Roboto">
                <h1>Барааны дэлгэрэнгүй</h1>
              </ModalHeader>
              <ModalBody>
                <div className="font-Roboto ">
                  <div className="mb-3 flex items-center gap-2">
                    <Input value={pay} onChange={(e)=> setPay(e.target.value)} placeholder="Карго төлбөр оруулах" size="sm"/>
                    <Button onClick={Sub}>Хадгалах</Button>
                  </div>
                <Table aria-label="Example static collection table">
                  <TableHeader>
                    <TableColumn>Утасны дугаар</TableColumn>
                    <TableColumn>Захиалгын тоо</TableColumn>
                    <TableColumn>Нийт</TableColumn>
                    <TableColumn>Карго</TableColumn>
                    <TableColumn>Хүлээлгэж өгсөн огноо</TableColumn>
                    <TableColumn>Төлөв</TableColumn>
                  </TableHeader>
                  <TableBody>
                    {
                      data.map((it, index) => {
                        return(
                          <TableRow key={index}>
                            <TableCell>
                              <h1>
                              {it.order.user.username}
                              </h1>
                              <h1>
                              {it.order.user.phone_no}
                              </h1>
                            </TableCell>
                            <TableCell>{it.quantity}</TableCell>
                            <TableCell>{Number(it.quantity)*Number(it.cargo)}</TableCell>
                            <TableCell>{it.cargo}</TableCell>
                            <TableCell>{it.date}</TableCell>
                            <TableCell>
                              <h1 className='flex items-center gap-3'>
                                {it.status === TYPES.REQUESTED && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Хүлээгдэж байгаа</h1>
                                    </div>
                                )}
                                {it.status === TYPES.CONFIRM && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Хүлээлгэж өгсөн</h1>
                                    </div>
                                )}
                                {it.status === TYPES.APPROVED && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Баталгаажсан</h1>
                                    </div>
                                )}
                                 {it.status === TYPES.IRSEN && (
                                    <div className='flex items-center gap-2'>
                                        <div className='h-3 w-3 rounded-full bg-gray-400'></div>
                                        <h1 className='text-xs font-bold uppercase border rounded-xl p-1'>Ирсэн</h1>
                                    </div>
                                )}
                              </h1>
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
                </div>
              </ModalBody>
              <ModalFooter>
                <div className="flex items-center gap-2">
                  <h1 className="bg-gray-200 rounded-md p-1">Нийт: {data.length}</h1>
                  <h1 className="bg-gray-200 rounded-md p-1">Хүлээгдэж байгаа: {sss(TYPES.REQUESTED)}</h1>
                  <h1 className="bg-gray-200 rounded-md p-1">Ирсэн: {sss(TYPES.IRSEN)}</h1>
                  {/* <h1 className="bg-gray-200 rounded-md p-1">Буцаалт хийсэн: {sss(TYPES.REJECTED)}</h1> */}
                  <h1 className="bg-gray-200 rounded-md p-1">Хүлээлгэж өгсөн: {sss(TYPES.CONFIRM)}</h1>
                </div>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}